import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
const messageIsSymbol = {reflectSymbol: () => "message"};
const pathIsSymbol = {reflectSymbol: () => "path"};
const ErrorIsSymbol = {reflectSymbol: () => "Error"};
const eq1 = /* #__PURE__ */ Data$dEq.eqArrayImpl(Data$dEq.eqStringImpl);
const $$Error = x => x;
const udecode = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(messageIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordCons(pathIsSymbol)({
      unsafeDecode: Unscramble.decodeArray(Unscramble.decodeString)
    })(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
  }
))();
const newtypeError = {Coercible0: () => {}};
const genericError = {to: x => x, from: x => x};
const showError = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dShow.showArrayImpl(Data$dShow.showStringImpl);
      return {genericShowArgs: v => ["{ message: " + Data$dShow.showStringImpl(v.message) + ", path: " + $0(v.path) + " " + "}"]};
    })())(ErrorIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const eqError = {eq: x => y => x.message === y.message && eq1(x.path)(y.path)};
const encodeError = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericError)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(ErrorIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(pathIsSymbol)((() => {
      const encode1 = Data$dFunctor.arrayMap(Unsafe$dCoerce.unsafeCoerce);
      return {encodeWithOptions: v => encode1};
    })()))(messageIsSymbol)({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeError = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericError)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ErrorIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(pathIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Foreign$dGeneric$dClass.arrayDecode(Foreign$dGeneric$dClass.stringDecode).decode;
    return {decodeWithOptions: v => decode2};
  })())())(messageIsSymbol)({decodeWithOptions: v => Foreign$dGeneric$dClass.readString})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {$$Error as Error, ErrorIsSymbol, decodeError, encodeError, eq1, eqError, genericError, messageIsSymbol, newtypeError, pathIsSymbol, showError, udecode};
